import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import ACTIONS from './storeActions';
import run from './run';
import notes from './notes';
import user from './user';
import exerciseDocuments from './exerciseDocuments';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

const getDefaultState = () => ({
  token: null,
  snackbar: {
    text: null,
    color: null
  },
  language: navigator.language.substring(0, 2)
})

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: getDefaultState(),
  modules: {
    run,
    notes,
    user,
    exerciseDocuments,
  },
  getters: {
    token(state) {
      return () => state.token;
    },
    snackbar(state) {
      return () => state.snackbar;
    },
    language(state) {
      return () => state.language;
    },
  },
  mutations: {
    [ACTIONS.SET_TOKEN]: (state, payload) => {
      state.token = payload
    },
    [ACTIONS.SET_SNACKBAR]: (state, { color, text }) => {
      state.snackbar.color = color;
      state.snackbar.text = text;
    },
    [ACTIONS.CLEAR_STATE]: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    [ACTIONS.SET_TOKEN]: (context, payload) => {
      context.commit(ACTIONS.SET_TOKEN, payload);
    },
    [ACTIONS.SET_SNACKBAR]: (context, payload) => {
      context.commit(ACTIONS.SET_SNACKBAR, payload);
    },
    [ACTIONS.CLEAR_STATE]: (context) => {
      context.commit(ACTIONS.CLEAR_STATE);
    }
  },
})
